// src/config.js
let apiBaseUrl;
let apiReportesUrl;

// Detecta si es dev o prod
if (process.env.NODE_ENV === "development") {
  // Desarrollo
  apiBaseUrl     = "http://localhost:8082/api/v1";
  apiReportesUrl = "http://localhost:8082/api/v1/reportes/pdf";
} else {
  // Producción
  apiBaseUrl     = "/api/v1";
  apiReportesUrl = "/api/v1/reportes/pdf";
}

export default {
  apiBaseUrl,
  apiReportesUrl
};
